import { React, ReactRouter } from 'mcelroy-lib'

/*
    Parse search query of url into map with array of values
    probably should be moved to mcelroy-lib
    Old Tapestry passed the same parameter (sp) multiple times and other
    libs like react-router don't handle that well.
*/
export function useQuery() {
    const { search } = ReactRouter.useLocation()
    return React.useMemo(function () {
        const params = {}
        const urlParams = new URLSearchParams(search)
        for (const p of urlParams) {
            if (params[p[0]] == null)
                params[p[0]] = []
            params[p[0]].push(p[1])
        }
        return params
    }, [search])
}
